<script>
  import Section from "$lib/components/Section.svelte";
  import SplitLayout from "$lib/components/SplitLayout.svelte";
  import Link from "$lib/components/Link.svelte";
  import { ImageContent } from "@ObamaFoundation/of-design-system";
  import { buildSrc } from "$lib/utilities/components/image-helpers";
  import { srcSetFromWidths, sizesForBreakpoints, SRCSET_WIDTHS } from "$lib/utilities";
  import { Markdown } from "@ObamaFoundation/of-design-system";

  export let specificLocation;
  export let venue;

  const sizes = sizesForBreakpoints({ sm: "100vw", lg: "50vw" });

  const venueImage = venue?.venueImage
    ? {
        src: buildSrc(venue?.venueImage),
        srcset: srcSetFromWidths(venue?.venueImage?.fields?.file?.url, SRCSET_WIDTHS),
        sizes,
        alt: venue?.venueImage.fields?.description
      }
    : null;

  const locationMap = specificLocation?.mapImage
    ? {
        src: buildSrc(specificLocation?.mapImage),
        srcset: srcSetFromWidths(specificLocation?.mapImage?.fields?.file?.url, SRCSET_WIDTHS),
        sizes,
        alt: `A map of ${specificLocation.locationName}`
      }
    : null;

  let heading;
  let description;
  let locationUrl;
  if (specificLocation && specificLocation.directions && specificLocation.locationCoordinates) {
    heading = specificLocation.locationName;
    description = specificLocation.directions;
    locationUrl = `https://www.google.com/maps?q=${specificLocation.locationCoordinates.lat},${specificLocation.locationCoordinates.lon}`;
  } else {
    heading = venue.name;
    description = venue.hours;
    locationUrl = venue.addressLink;
  }
</script>

<Section class="embedded-content pt-5" variant="small" id="location-information">
  <SplitLayout variant="50/50" id="location-information-layout">
    <div slot="leftComponent">
      <h2 class="heading-xs rich-text pb-10">{heading}</h2>
      <Markdown input={description} />
      <br />
      {#if locationUrl}
        <Link
          label={heading}
          variant="small"
          url={locationUrl}
          target="_blank"
          rel="noopener noreferrer"
          leadingIcon="location"
        />
      {:else if venue.obamaorgUrl}
        <Link
          label={`Explore ${venue.name}`}
          variant="small"
          url={venue.obamaorgUrl}
          isExternal={false}
          rel="noopener noreferrer"
        />
      {/if}
    </div>
    <div slot="rightComponent">
      {#if locationMap}
        <ImageContent
          containerClasses="embedded-content rich-text"
          aspectRatio="square"
          image={locationMap}
        />
      {:else if venueImage}
        <ImageContent
          containerClasses="embedded-content rich-text"
          aspectRatio="square"
          image={venueImage}
        />
      {/if}
    </div>
  </SplitLayout>
</Section>
